import { localeEnhancer } from '@biw/intl';
import HtmlContent from './html-content';

export default localeEnhancer( HtmlContent );
